import IPixelMapDay from "@interfaces/pixel-map-day.interface";

const octoberMap: Array<IPixelMapDay> = [
];

export default octoberMap;
